<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title class="headline">{{ question }}</v-card-title>

      <v-card-text>{{ subtext }}</v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="show = false">sluiten</v-btn>

        <v-btn color="green darken-1" text @click="$emit('confirm')"
          >Bevestig</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
    },
    question: {
      type: String,
    },
    subtext: {
      type: String,
      required: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>

<style>
</style>